import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '@/lib/analytics';
import { useFilters } from '@/contexts/FilterContext';

export function usePageTracking() {
  const location = useLocation();
  const { locationLabel, locationSource } = useFilters();

  useEffect(() => {
    const name = getPageName(location.pathname);
    analytics.pageView(location.pathname, name, locationLabel, locationSource);
  }, [location.pathname, locationLabel, locationSource]);
}

function getPageName(path: string): string {
  const routes: Record<string, string> = {
    '/specials': 'Specials',
    '/events': 'Events',
    '/happy-hours': 'Happy Hours',
    '/bars': 'Bars',
    '/favorites': 'Favorites',
    '/search': 'Search',
    '/login': 'Login',
    '/settings': 'Settings',
    '/help': 'Help',
    '/feedback': 'Feedback',
  };

  if (routes[path]) return routes[path];
  if (path.startsWith('/bars/')) return 'Bar Detail';
  if (path.startsWith('/city/')) return 'City Landing';
  if (path.startsWith('/admin')) return 'Admin';
  if (path.startsWith('/settings/')) return 'Settings';

  return 'Unknown';
}
